import { all_routes } from "../../../feature-module/router/all_routes";
import { SYSTEM_ROLES } from "../../../feature-module/router/roleConfig";
const route = all_routes;
export const SidebarData = [
  {
    label: "MAIN MENU",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Opportunities Dashboard", link: route.dealsDashboard },
          { label: "Leads Dashboard", link: route.leadsDashboard },
        ],
      }
    ],
  },
  // {
  //   label: "Layout",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Inventory",
  //   submenuItems: [
  //     {
  //       label: "Mini",
  //       link: route.layoutMini,
  //       icon: "ti ti-layout-navbar",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Horizontal Signle",
  //       link: route.HorizontalSingle,
  //       icon: "ti ti-layout-navbar-inactive",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Without Header",
  //       link: route.WithoutHeader,
  //       icon: "ti ti-layout-sidebar",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "RTL",
  //       link: route.layoutRtl,
  //       icon: "ti ti-text-direction-rtl",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Detached",
  //       link: route.Detached,
  //       icon: "ti ti-details",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Dark",
  //       link: route.Dark,
  //       icon: "ti ti-moon",
  //       showSubRoute: false,
  //       submenu: false,
  //     },

  //   ],
  // },
  {
    label: "CRM",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",

    submenuItems: [
      {
        label: "Users",
        link: route.users,
        icon: "ti ti-user-pin",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ADMIN]
      },
      {
        label: 'Calendar',
        link: route.calendar,
        icon: "ti ti-calendar-event",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Contacts",
        link: route.contactList,
        subLink1: route.contactGrid,
        subLink2: route.contactDetails,
        icon: "ti ti-user-up",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Companies",
        link: route.companies,
        subLink1: route.companyDetails,
        subLink2: route.companiesGrid,
        icon: "ti ti-building-community",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Opportunities",
        link: route.deals,
        subLink1: route.dealsKanban,
        subLink2: route.dealsDetails,
        icon: "ti ti-medal",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Leads",
        link: route.leads,
        subLink1: route.leadsDetails,
        subLink2: route.leadsKanban,
        icon: "ti ti-chart-arcs",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Pipelines",
        link: route.pipeline,
        icon: "ti ti-timeline-event-exclamation",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ADMIN]
      },
      {
        label: "Tags",
        link: route.tag,
        icon: "ti ti-tags",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Campaigns",
        link: route.campaign,
        icon: "ti ti-brand-campaignmonitor",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: 'Email Templates',
        link: route.emailTemplate,
        icon: "ti ti-mail",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Products",
        link: route.products,
        icon: "ti ti-atom-2",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "Tasks",
        link: route.tasks,
        subLink1: route.tasksCompleted,
        subLink2: route.tasksImportant,
        icon: "ti ti-list-check",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.MARKETING, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      },
      {
        label: "PriceBooks",
        link: route.pricebook,
        icon: "ti ti-report-money",
        showSubRoute: false,
        submenu: false,
        roles: [SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.ACCOUNT_EXECUTIVE, SYSTEM_ROLES.SALE_MANAGER, SYSTEM_ROLES.SDR]
      }
    ],
  },
  // {
  //   label: "MEMBERSHIP",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Finance & Accounts",
  //   submenuItems: [
  //     {
  //       label: "Membership",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-file-invoice",
  //       submenuItems: [
  //         {
  //           label: "Membership Plans",
  //           link: route.membershipplan,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Membership Addons",
  //           link: route.membershipAddon,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Transactions",
  //           link: route.membershipTransaction,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   label: "SUPPORT",
  //   submenuOpen: true,
  //   submenuHdr: "Purchases",
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Content Messages",
  //       link: route.contactMessages,
  //       icon: "ti ti-page-break",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Tickets",
  //       link: route.tickets,
  //       icon: "ti ti-ticket",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },

  // {
  //   label: "Settings",
  //   submenu: true,
  //   showSubRoute: false,
  //   submenuHdr: "Settings",
  //   submenuItems: [
  //     {
  //       label: "General Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-settings-cog",
  //       submenuItems: [
  //         { label: "Profile", link: route.profile },
  //         { label: "Security", link: route.security },
  //         { label: "Notifications", link: route.notification },
  //         { label: "Connected Apps", link: route.connectedApps },
  //       ],
  //     },
  //     {
  //       label: "Website Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-world-cog",
  //       submenuItems: [
  //         {
  //           label: "Company Settings",
  //           link: route.companySettings,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Localization",
  //           link: route.localization,
  //           showSubRoute: false,
  //         },
  //         { label: "Prefixes", link: route.prefixes, showSubRoute: false },
  //         { label: "Preference", link: route.preference, showSubRoute: false },
  //         { label: "Appearance", link: route.appearance, showSubRoute: false },
  //         {
  //           label: "Language",
  //           link: route.language,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //       label: "App Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-apps",
  //       submenuItems: [
  //         {
  //           label: "Invoice",
  //           link: route.invoiceSettings,
  //           showSubRoute: false,
  //         },
  //         { label: "Printer", link: route.printers, showSubRoute: false },
  //         {
  //           label: "Custom Fields",
  //           link: route.customFields,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //       label: "System Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-device-laptop",
  //       submenuItems: [
  //         { label: "Email", link: route.emailSettings, showSubRoute: false },
  //         {
  //           label: "SMS Gateways",
  //           link: route.smsGateways,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "GDPR Cookies",
  //           link: route.gdprCookies,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //       label: "Financial Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-moneybag",
  //       submenuItems: [
  //         {
  //           label: "Payment Gateway",
  //           link: route.paymentGateways,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Bank Accounts",
  //           link: route.bankAccounts,
  //           showSubRoute: false,
  //         },
  //         { label: "Tax Rates", link: route.taxRates, showSubRoute: false },
  //         {
  //           label: "Currencies",
  //           link: route.currencies,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //       label: "Other Settings",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-flag-cog",
  //       submenuItems: [
  //         { label: "Storage", link: route.storage, showSubRoute: false },
  //         {
  //           label: "Ban IP Address",
  //           link: route.banIpAddrress,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //   ],
  // },

];
